import React, { useState, useRef, useEffect } from "react";
import LogoIcone from "../../../../assets/notifyicone.png";
import PrivateMenuLeft from "../../sections/Header/privateMenuLeft";
import PrivateMenuUp from "../../sections/Header/privateMenuUp";
import MenuViewBroadcast from "./menuViewBroadCast";
import ViewBroadcastLinkedZap from "./ViewBroadCastLinkedZap";
import ViewBroadcastLeads from "./ViewBroadCastLeads";
import ViewBroadcastOperationIndex from "./operation/ViewBroadcastOperationIndex";
import useAuth from "../../../../components/hooks/useAuth";
import { useParams } from "react-router-dom";



const HEADER_HEIGHT = 56;

const ViewBroadcast = () => {
  const [activeTab, setActiveTab] = useState('contas');
  const { sidebarOpen, getApi, postApi } = useAuth();
  const { id: broadcastId, operation:operationParams } = useParams();

  useEffect(() => {
    const initialize = async () => {
     if(operationParams){
      setActiveTab(operationParams);
     }else{
            setActiveTab('contas');
     }
    };

    initialize();
  }, [operationParams]);

  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
      {/* Sidebar Bootstrap 5 */}
      <PrivateMenuLeft />
      <PrivateMenuUp />
      {/* Conteúdo da página de campanha */}
      <div style={{
        marginLeft: window.innerWidth > 768 ? (sidebarOpen ? 220 : 70) : 0,
        paddingTop: HEADER_HEIGHT,
        width: window.innerWidth > 768
          ? sidebarOpen
            ? "calc(100% - 220px)"
            : "calc(100% - 70px)"
          : "100vw",
        transition: "margin-left 0.3s, padding-top 0.3s, width 0.3s",
      }}>
        <div style={{ padding: 16 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <h2 style={{ margin: 0, color: '#005c53', fontWeight: 'bold' }}>Broadcasts</h2>
            </div>
          </div>

          <div style={{ marginTop: 12 }}>

            <MenuViewBroadcast setActiveTab={setActiveTab} activeTab={activeTab} />

            <div style={{ marginTop: 16 }}>
              {activeTab === 'contas' && (
                <ViewBroadcastLinkedZap broadcastId={broadcastId}/>
              )}




              {activeTab === 'leads' && (
                <ViewBroadcastLeads broadcastId={broadcastId}/>
              )}



              {activeTab === 'operacoes' && (
                <ViewBroadcastOperationIndex broadcastId={broadcastId}/>
              )}
            </div>
          </div>
        </div>

        
      </div>
    </div>
  );
};

export default ViewBroadcast;